import { MDBBtn, MDBCol } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IEmpresa, newEmpresa } from "../../model";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { formatCnpj } from "../../utils";
import { Pager } from "../utils/Pager";
import moment from "moment";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";
import { Alert } from "@blueprintjs/core";
import { SpedApuracaoStore } from "../../stores/sped/SpedApuracaoStore";

@observer
export class Relatorios extends React.Component<{}, {}> {

  obs = observable({
    date_periodo_relatorio: [] as any,
    selectEmpresa: newEmpresa() as IEmpresa,
    erros_relatorio: [] as any,
    relatorios: [] as any,
    open_erros_relatorio : false
  })

  constructor(props: any) {
    super(props);
  }

  /**
 * Altera a página atual da lista de tarefas de relatório e carrega os dados correspondentes.
 * 
 * A função:
 * 1. Atualiza o estado observável `page_tasks_relatorio` com o número da nova página.
 * 2. Chama a função `handleTasksPaged` para buscar os dados da página selecionada.
 * 
 * Essa função é útil em componentes de paginação para atualizar a lista de relatórios
 * conforme o usuário navega entre as páginas.
 * 
 * @async
 * @param {number} page Número da página que deve ser exibida.
 * 
 * @returns {Promise<void>} Retorna uma Promise resolvida após a atualização da página e o carregamento dos dados.
 */

  async handleChangePage(page: number) {

    SpedApuracaoStore.obs.page_tasks_relatorio = page

    await SpedApuracaoStore.handleTasksPaged(SpedApuracaoStore.obs.page_tasks_relatorio)

  }

  /**
 * Processa uma string de erros e atualiza o estado observável para exibição.
 * 
 * A função:
 * 1. Recebe uma string contendo mensagens de erro separadas por vírgula.
 * 2. Converte essa string em uma lista (`array`) de erros individuais.
 * 3. Mapeia cada erro para um objeto no formato `{ erros: string }`.
 * 4. Armazena a lista no estado observável `erros_relatorio`.
 * 5. Define `open_erros_relatorio` como `true` para exibir os erros na interface.
 * 
 * Essa função é útil para processar respostas de backend que enviam erros agregados em uma única string.
 * 
 * @param {string} error String contendo as mensagens de erro separadas por vírgula.
 * 
 * @returns {void} Não retorna valor, apenas atualiza o estado observável.
 */

  handleErrosRelatorio(error: string) {
          let list_erros = error.split(",")
          this.obs.erros_relatorio = list_erros?.map(x => {
              return { "erros": x }
          })
          this.obs.open_erros_relatorio = true
      }

/**
 * Fecha o painel/modal de erros de relatório e limpa a lista de erros exibidos.
 * 
 * A função:
 * 1. Define `open_erros_relatorio` como `false`, ocultando a interface de exibição de erros.
 * 2. Limpa o array `erros_relatorio`, removendo todas as mensagens armazenadas.
 * 
 * Essa função é normalmente chamada quando o usuário fecha manualmente o painel de erros
 * ou após a correção das falhas reportadas.
 * 
 * @returns {void} Não retorna valor, apenas atualiza o estado observável.
 */

  onCloseErros() {
          this.obs.open_erros_relatorio = false
          this.obs.erros_relatorio = []
      }

  /**
 * Atualiza a lista de tarefas de relatório, reiniciando a paginação.
 * 
 * A função:
 * 1. Define `page_tasks_relatorio` como `1`, reiniciando para a primeira página.
 * 2. Zera o contador de tarefas (`length_tasks_relatorio`).
 * 3. Chama `handleTasksPaged(1)` para buscar os dados mais recentes da primeira página.
 * 
 * Essa ação é útil para recarregar os relatórios após novas solicitações, exclusões
 * ou alterações no backend.
 * 
 * @async
 * @returns {Promise<void>} Retorna uma Promise resolvida após a atualização da lista.
 */

  async handleAtualizar() {
    SpedApuracaoStore.obs.page_tasks_relatorio = 1
    SpedApuracaoStore.obs.length_tasks_relatorio = 0

    await SpedApuracaoStore.handleTasksPaged(1)  
  }

  render() {

    let items = SpedApuracaoStore.obs.tasks_relatorio?.map(imp => {

      return ({
        id: imp._id,
        cnpj: imp.cnpj,
        razao_social: imp.razao_social,
        inserted_at: imp.inserted_at,
        date_start: imp.date_start,
        date_end: imp.date_end,
        status: imp.status,
        relatorio_id: imp.relatorio_id,
        error: imp.error,
        tipo_exportacao: imp.tipo_exportacao
      });

    });

    function statusFormatter(cell, row) {

      return getTag(row.status, "relatorio");

    }

    const errosFormatter = (cell, row) => {
                return (
                    <>
                        <MDBBtn
                            color="default"
                            rounded
                            size="sm"
                            disabled={row.status != 3}
                            onClick={() => this.handleErrosRelatorio(row.error)}
                        >
                            <img src="/images/view.png" />
                        </MDBBtn>
                    </>
                );
            }



    function fileFormatter(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            disabled={row.status != 2}
            onClick={() => SpedApuracaoStore.handleDownloadArquivoRelatorio(row.relatorio_id, row.cnpj)}
          >
            <img src="/images/download.svg" />
          </MDBBtn>
        </>
      );
    }

    const dateFormatter = (cell, row) => {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " às " + moment(cell).add(3, "hour").format("HH:mm");
    };

    const cnpjFormatter = (cell, row) => {
      return formatCnpj(row.cnpj)
    };

    const periodoFormatter = (cell, row) => {
      return moment(row.date_start).add(3, "hour").format("DD/MM/YYYY") + " - " + moment(row.date_end).add(3, "hour").format("DD/MM/YYYY");
    };

    return (
      <>
        <MDBCol md="2">
          <MDBBtn
              className="btnDefault btnBuscarNfe mt25"
              onClick={() => this.handleAtualizar()}
          >
              Atualizar
          </MDBBtn>
      </MDBCol>

        <div data-tut="table">
          <BootstrapTable className="TableDefault" ref="table" data={items}>
            <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataField="razao_social" width="30%">Razão Social</TableHeaderColumn>
            <TableHeaderColumn dataFormat={cnpjFormatter} dataField="cnpj" width="20%">CNPJ</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="15%">Criado em</TableHeaderColumn>
            <TableHeaderColumn dataFormat={periodoFormatter} width="15%">Período</TableHeaderColumn>
            <TableHeaderColumn dataField="status" dataFormat={statusFormatter} width="30%">Status</TableHeaderColumn>
            <TableHeaderColumn dataFormat={fileFormatter} width="10%">Arquivo</TableHeaderColumn>
            <TableHeaderColumn dataFormat={errosFormatter} width="10%">Erros</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={SpedApuracaoStore.obs.page_tasks_relatorio}
            totalCount={SpedApuracaoStore.obs.length_tasks_relatorio}
            pageSize={15}
            onPageChange={page => this.handleChangePage(page)}
          />
        </div>

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.open_erros_relatorio}
          onClose={() => this.onCloseErros()}
          onConfirm={() => this.onCloseErros()}
          canOutsideClickCancel={true}
          className="AlertErrorSped"
      >
          <h2 className="titleSEFAZ">Erros</h2>
          <MDBCol md="12">
              {this.obs.erros_relatorio.length &&
                  <div className="errosSped">
                      <BootstrapTable className="nomeArquivos" data={this.obs.erros_relatorio} hover>
                          <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                          <TableHeaderColumn dataField='erros' width='100%'></TableHeaderColumn>
                      </BootstrapTable>
                  </div>
              }
          </MDBCol>
      </Alert>

        <LoadingModal open={SpedApuracaoStore.obs.loading_apuracao} onClose={() => SpedApuracaoStore.obs.loading_apuracao = false} title={"Gerando apuração"} />
        <LoadingModal open={SpedApuracaoStore.obs.loading_solicitacao} onClose={() => SpedApuracaoStore.obs.loading_solicitacao = false} title={"Gerando arquivo Excel"} />
        <LoadingModal open={SpedApuracaoStore.obs.loading_download} onClose={() => SpedApuracaoStore.obs.loading_download = false} title={"Baixando arquivo"} />
      </>
    )
  }
}

export default Relatorios;
